import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import {UserProfileStyles as styles} from "./UserProfile.styles"

/**
 * Current user image and name linked to the user profile.
 * @param {string} userPic - Path to the user profile image.
 * @param {string} userName - User name.
 * @returns {boolean|JSX.Element}
 */
const UserProfile = ({userPic, userName}) => (
  <Box className={"UserProfile__wrapper"} sx={styles}>
    <Link className={"UserProfile__avatar"} to={"/Profile"}>
      {
        userPic
          ? <Avatar
            variant="circular"
            alt="User Profile icon"
            src={userPic}
            />
          : <div className={"UserProfile__missing-avatar"}> ? </div>
      }
      <span className={"UserProfile__name"}>{userName || "Missing Name"}</span>
    </Link>
  </Box>
);

UserProfile.propTypes = {
  userPic: PropTypes.string,
  userName: PropTypes.string,
}

export default React.memo(UserProfile);
